import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from './GenericConfirmationDialog.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toast3qlkoaxwmk6x7 as toast } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance } from '../theming/Titles.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function confirmNewSpecDialog(_this__u8e3s4, newSpec) {
  var tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  var this_0 = newSpec.y83_1;
  if (!isBlank(this_0)) {
    tmp = 'Description: ' + newSpec.y83_1;
  } else {
    tmp = '';
  }
  var tmp_0 = trimIndent('\n            Title: ' + newSpec.x83_1 + '\n            ' + tmp + '\n        ');
  confirmationDialog(_this__u8e3s4, 'Create A New Specification?', tmp_0, 'Create', VOID, VOID, VOID, VOID, VOID, VOID, confirmNewSpecDialog$slambda_0(newSpec, _this__u8e3s4));
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.ofv_1.zen($this.si8_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  toast($this.ti8_1, VOID, confirmNewSpecDialog$slambda$lambda);
  return Unit_instance;
}
function confirmNewSpecDialog$slambda$lambda($this$toast) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$toast.pc());
  var tmp0_elvis_lhs = $this$toast.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$toast : tmp0_elvis_lhs;
  $this$toast.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
  view.eba(get_rem(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'Spec Created';
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.fbu(tmp_0);
  $this$toast.fbb(p, view);
  return view;
}
var confirmNewSpecDialog$slambdaClass;
function confirmNewSpecDialog$slambda() {
  if (confirmNewSpecDialog$slambdaClass === VOID) {
    class $ {
      constructor($newSpec, $this_confirmNewSpecDialog) {
        this.si8_1 = $newSpec;
        this.ti8_1 = $this_confirmNewSpecDialog;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    confirmNewSpecDialog$slambdaClass = $;
  }
  return confirmNewSpecDialog$slambdaClass;
}
function confirmNewSpecDialog$slambda_0($newSpec, $this_confirmNewSpecDialog) {
  var i = new (confirmNewSpecDialog$slambda())($newSpec, $this_confirmNewSpecDialog);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  confirmNewSpecDialog as confirmNewSpecDialog2atpg2wu5rk54,
};
//endregion

//# sourceMappingURL=ConfirmNewSpecDialog.mjs.map
